import * as React from 'react';

export interface IndGenderSelectProps {
  userAccessToken: string;
  userId: number;
  disabled?: boolean;

  onChange?: (age: number) => void;

  value: number;
}

export const IndAgeSelect = (props: IndGenderSelectProps): React.JSX.Element => {
  const [value, setValue] = React.useState<number>(props.value);

  return (
    <>
      <div>
        <input
          disabled={props.disabled}
          type="number"
          value={value}
          onChange={(e) => {
            const newAge = parseInt(e.target.value);
            setValue(newAge);

            if (props.onChange) {
              props.onChange(newAge);
            }
          }}
        />
      </div>
    </>
  );
};
